import { numCompare } from "@common/Common";
import { DisagreementItem } from "@Evaluation/Estimations/Domain/readmodels";

export class DisagreementsDialogViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    questions: DisagreementItem[] = [];

    show()
    {
        this.initialized = false;
        this.questions = [];

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.questions = [];

    }

    setData(items: DisagreementItem[])
    {
        this.questions = items
            .sort((a, b) => numCompare(a.DisagreementRatio, b.DisagreementRatio))
            .reverse();

        this.initialized = true;
    }
}